module.exports = __webpack_public_path__ + "img/together-alone-visual.a0e358b5.webp";